import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_MANUAL_ASSET_READING_SUCCESS,
  FETCH_MANUAL_ASSET_LAST_READING_SUCCESS,
  FETCH_MANUAL_ASSET_LAST_READING_WITH_TIME_SUCCESS,
  FETCH_MANUAL_ASSET_READING_SUCCESS,
  GET_MANUAL_ASSET_READING_SUCCESS,
  SAVE_MANUAL_ASSET_READING_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchFilter, fetchStart, fetchSuccess, } from "./Common";
import { message } from "antd";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_MANUAL_ASSET_READING_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_MANUAL_ASSET_READING_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_MANUAL_ASSET_READING_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  console.log(`Here > - ${data}`);
  return {
    type: FETCH_MANUAL_ASSET_READING_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { manualAssetReading } = store.getState();
      const { query } = manualAssetReading;
      const response = await axios.get(`/manual-asset-reading?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      // message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect = true, module, subMaster = false) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/manual-asset-reading`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
      }
      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/manual-asset-reading');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.put(`/manual-asset-reading/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      history.push('/manual-asset-reading');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/manual-asset-reading/${id}`);
      // console.log(`Here - ${response.data}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.delete(`/manual-asset-reading/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getLastReading = (asset, meter) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/manual-asset-reading/last-reading/${asset}/${meter}`);
      console.log(`Here - ${response.data}`);
      dispatch(fetchSuccess());
      dispatch(fetchLastReadingSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchLastReadingSuccess = ({ data }) => {
  return {
    type: FETCH_MANUAL_ASSET_LAST_READING_SUCCESS,
    data
  };
};

export const getLastReadingTimeBased = (asset, meter, timestamp) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let time = timestamp
      if (String(timestamp).length === 13)
        time = timestamp / 1000;
      const response = await axios.get(`/manual-asset-reading/last-reading-with-time/${asset}/${meter}/${time}`);
      // console.log(`Here - ${response.data}`);
      dispatch(fetchSuccess());
      dispatch(fetchLastReadingWithTimeSuccess({ data: response.data, assetId: asset, meterId: meter, timestamp: timestamp }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchLastReadingWithTimeSuccess = ({ data, assetId, meterId, timestamp }) => {
  return {
    type: FETCH_MANUAL_ASSET_LAST_READING_WITH_TIME_SUCCESS,
    data,
    assetId,
    meterId,
    timestamp
  };
};